import { render } from "./Main.vue?vue&type=template&id=18198f4a&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=18198f4a&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-18198f4a"

export default script